import {SingleTargetRelation} from '../SingleTargetRelation';
import type {ISketchObject} from "../../../../../mesh/sketch";


/**
 * 线关系约束抽象基类。
 * 职责：
 * 1. 统一线关系约束对象结构；
 * 2. 提供关系级几何落地入口，具体算法由子类覆盖。
 * @template TType 线关系类型。
 */
export function isSketchLineRelationConstraint(value: object): value is SketchLineRelationConstraint<any> {
    return Reflect.get(value, "isSketchLineRelationConstraint") === true;
}
export abstract class SketchLineRelationConstraint<T extends ISketchObject> extends SingleTargetRelation<T> {
    readonly isSketchLineRelationConstraint: boolean = true;
}


